module.exports = __webpack_public_path__ + "l.no1.32924496.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/l.no1.jpg
// module id = T+Ev
// module chunks = 0